var state = {
    isBottomPage: false,
    ready: false,
    scrollActive: false,
    scrollY: {
        bottom: 0,
        isDown: false,
        middle: 0,
        top: 0,
        vel: 0,
    },
    stage: {
        width: 0,
        height: 0,
        scrollWidth: 0,
        scrollHeight: 0,
        isLarge: false,
        isMedium: false,
        isSmall: false,
        isPortrait: false,
        isLandscape: false,
        isSquare: false,
    },
    headerHeight: -1,
    footerHeight: -1,
    isMenuOpen: false,
    isModalOpen: false,
    loadProgress: false,
    menuOpenProgress: false,
    menuCloseProgress: false,
    modalOpenProgress: false,
    modalCloseProgress: false,
    transitionProgress: false,
    enterProgress: false,
    leaveProgress: false,
    pageName: "",
    isHoverAtTopExperienceItem: false,
};
export default state;
